import layoutAdmin from '@/layouts/layoutAdmin.vue';
import purpose from '@/views/module/resource/purpose/purpose.vue';


export default [
    {
      path: '/resource',
      component: layoutAdmin,
      meta: {
        UserLoggedIn: true,
        breadcrumb: 'Resource Management',
      },
      children:[
        {
          path: "purpose",
          name: "purpose",
          meta: {
            breadcrumb: ['Resource' , "Purpose"],
          },
          component: purpose,
        },
      ],
      
    },
    
  ]


  